module.exports = __webpack_public_path__ + "static/mission-img-6-42f41254ebadd113a89c7f460589dc8f.jpg";